import { render, staticRenderFns } from "./StandardButton.vue?vue&type=template&id=03aea7e8"
import script from "./StandardButton.vue?vue&type=script&lang=js"
export * from "./StandardButton.vue?vue&type=script&lang=js"
import style0 from "./StandardButton.vue?vue&type=style&index=0&id=03aea7e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports